import Api from '../Base'

class GetSharePointNominations extends Api {
  requestUrl = `/api/sharePointNomination/`

  formatResponseData = response => response.data
}

export default GetSharePointNominations
